import { AiStarsGradientIcon } from '~/components/common/Icon';

import { useSmartSearchStore } from '~/store/common';

import SmartSearchFeedback from './SmartSearchFeedback';
import SmartSearchQuestionList from './SmartSearchQuestionList';

import type { TypeSmartSearchResult } from '~/types/smart-search.types';

import styles from './SmartSearchResult.module.scss';

type SmartSearchResultProps = {
  data: TypeSmartSearchResult;
};

const SmartSearchResult = ({ data }: SmartSearchResultProps) => {
  const { submitSearch, setInputValue } = useSmartSearchStore((state) => state.actions);

  const handleClickRelatedQuestion = (question: string) => {
    setInputValue(question);
    submitSearch(question);
  };

  return (
    <div className={styles['result']}>
      <div className={styles['answer-section']}>
        <div className={styles['answer-header']}>
          <AiStarsGradientIcon size={16} />
          <span className={styles['answer-header-text']}>AI 요약</span>
        </div>
        <div className={styles['answer-body']}>{data.answer}</div>
        <SmartSearchFeedback queryId={data.queryId} />
      </div>

      <SmartSearchQuestionList
        title="관련 질문"
        questions={data.relatedQuestions.map((item) => ({ key: item.faqId, question: item.question }))}
        onClickQuestion={handleClickRelatedQuestion}
        bordered
      />
    </div>
  );
};

export default SmartSearchResult;
